import React from "react";
import banner from "../assets/banner5.jpg";

export default function WereniumTech() {
  return (
    <div className="MainBodySection py-5">
      <div className="container">
        <div className="row align-items-center mb-4">
          <div className="col-md-6 text-center">
            <img src={banner} alt="Werenium Technologies" className="img-fluid rounded" style={{maxHeight: '320px', objectFit: 'cover'}} />
          </div>
          <div className="col-md-6">
            <h2 className="main-section-title">Werenium Technologies (T) LTD</h2>
            <p className="text-muted">
              Werenium Technologies engineers the digital future. We build software, enterprise systems, automation tools, and mobile/web applications that power modern business processes and digital services.
            </p>
            <p className="text-muted">
              Combining product thinking with engineering excellence, Werenium partners with internal and external clients to deliver scalable, secure, and maintainable digital solutions tailored for African contexts.
            </p>
            <div className="my-3">
              <a className="btn btn-primary" href="https://werenium.com" target="_blank" rel="noreferrer">Visit Werenium Technologies</a>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
}
